import React, { useCallback, useContext, useEffect, useMemo, useRef } from 'react'
import { BettingOddsContext } from './BettingOddsContext'
import SwisslosBettingOdds, { makeInitialSwisslosRenderCall, notifySwisslosPickChange } from './SwisslosBettingOdds'
import { OneXTwoContext } from '@root/components/OneXTwoBet/WithOneXTwoBet'
import { BettingOddsUserPick } from './type'
import { OneXTwoBetPick } from '@root/components/OneXTwoBet/types'
import { EmptyPick, isEmptyPick } from '@root/bet_utils/types'

let _initialRenderCallDone = false

const betPickToBettingOddsUserPick = (pick: OneXTwoBetPick | EmptyPick): BettingOddsUserPick | undefined => {
  if (pick === 'home') { return "1" }
  if (pick === 'draw') { return "X" }
  if (pick === 'away') { return "2" }
  return undefined
}

const useBettingOddsPartner = () => {
  const { isAdult, partner } = useContext(BettingOddsContext)
  const { bet } = useContext(OneXTwoContext)
  const userBetPick = bet.picks?.[0]
  const isFirstCallForInitialUserPickRef = useRef(true)
  const partnerRef = useRef(partner)
  partnerRef.current = partner
  const initialPickRef = useRef(betPickToBettingOddsUserPick(userBetPick));
  const externalBetIdRef = useRef(bet.event_external_id)

  useEffect(() => { // make initial "fill placeholders" call
    window.setTimeout(() => {
      if (!_initialRenderCallDone) {
        _initialRenderCallDone = true
        if (partnerRef.current === 'swisslos') {
          makeInitialSwisslosRenderCall();
        }
      }
    }, 30)
  }, [])

  useEffect(() => { // send changed pick to odds partner
    const newPick = betPickToBettingOddsUserPick(userBetPick)
    if (isFirstCallForInitialUserPickRef.current) {
      isFirstCallForInitialUserPickRef.current = false
    } else {
      if (partnerRef.current === 'swisslos') {
        if (newPick) { notifySwisslosPickChange(externalBetIdRef.current, newPick) }
      }
    }
  }, [userBetPick])

  const BettingOddsComp = useMemo(() => {
    if (partner === 'swisslos') {
      return <SwisslosBettingOdds matchId={externalBetIdRef.current} initialPick={initialPickRef.current} />
    }
    return null
  }, [ partner ])

  return {
    BettingOddsComp
  }
}

export default useBettingOddsPartner
